import { PayloadAction, createReducer } from '@reduxjs/toolkit';
import { initialState } from '@modules/orders-and-trips/store';
import { getRestrictionRoutine } from '@modules/orders-and-trips/actions';
import { onFailure } from '@common/utils/helpers/reducers';
import { InitialState } from '@modules/orders-and-trips/types/general';
import { IEnum } from '@common/types';

export const getRestrictionReducer = createReducer(initialState, {
  [getRestrictionRoutine.REQUEST]: (state: InitialState) => {
    state.extraData.isFetching = true;
    return state;
  },
  [getRestrictionRoutine.SUCCESS]: (
    state: InitialState,
    action: PayloadAction<{
      data: IEnum<string>;
    }>
  ) => {
    const { data } = action.payload;
    state.extraData.restriction = data;
    return state;
  },
  [getRestrictionRoutine.FAILURE]: onFailure,
  [getRestrictionRoutine.FULFILL]: (state: InitialState) => {
    state.error = [];
    state.extraData.isFetching = false;
    return state;
  }
});

